import React from "react";
import { ParallaxBanner as RSParallaxBanner } from "react-scroll-parallax";
import { ParallaxProps } from "./Parallax";

export interface ParallaxBannerProps {
    /**
     * Height of the banner image in px
     */
    readonly height?: number;

    /**
     * Aspect ratio of the banner image.
     */
    readonly aspectRatio?: string;

    /**
     * Content that will be wrapped by the Parallax effect.
     */
    //tslint:disable-next-line:readonly-array react-scroll-parallax only accepts a mutable array
    readonly layers: BannerLayerProps[];
}

export interface BannerLayerProps extends ParallaxProps {
    readonly children: React.ReactNode;
}

export const ParallaxBanner: React.FC<ParallaxBannerProps> = ({
    aspectRatio,
    height,
    ...parallaxBannerProps
}) => {

    return (
        <RSParallaxBanner style={{aspectRatio, height}} {...parallaxBannerProps} />
    );
};
